/**
 * Created by yuning.jin on 17/1/16.
 */

import messageBoxVue from '@/components/common/MessageBox.vue'

export default {
	mixin: {
		data() {
			return {
				loadingShow:true
				//logger:null
			}
		},
		created() {
			//this.logger =  new window.Tracker('lyhdoctor.cn-hangzhou.log.aliyuncs.com','lyhdoctor','lyhloga');

		},
		methods: {
			goToCertify(pageSource,needOpenInApp){
				const url = `${Global_userCenter_serve}identity-authentication?page_source=${pageSource}`;
				if(needOpenInApp&&is_app()){
					nativefun('goToCommonWebPage', {
						param: {
						  url: url,
						  needNotShowShareBtn: 1
						}
					  });
				}else{
					if (is_app()) {
						nativefun('goToCommonWebPage', {
						  param: {
							url: url,
							needNotShowShareBtn: 1
						  }
						});
					  } else {
						window.location.href = url
					  }
				}
				
			},
			setpreredirct(path) {
				let saveobj = {
					path: path,
					time: gettimestamp()
				};
				let saveobjstr = JSON.stringify(saveobj);
				localStorage.setItem('preredirct', saveobjstr);
			},
			gopreredirct() {

				let nowtimesmp = gettimestamp();
				//alert(0);
				let saveobjstr = localStorage.getItem('preredirct');
				if (!saveobjstr) { //对象不存在
					return
				}
				//alert(1);

				let saveobj = JSON.parse(saveobjstr);
				//alert(2);
				if (!saveobj.path) { //对象格式有问题
					localStorage.removeItem('preredirct')
					return
				}
				//alert(3);
				let savetimesmp = parseInt(saveobj.time);
				//alert(4);
				if (nowtimesmp - savetimesmp > 300) { //对象超时
					localStorage.removeItem('preredirct')
					return
				}
				//alert(5);
				var linkurl = window.Global_root_path + '#/' + saveobj.path;
				//alert(saveobj.path)
				//alert(linkurl)
				location.href = linkurl;
				//return
			},
			appcheckLogin() {
				if (this.$root.platform == 'app') {
					if (!window.auth1) {
						gotoLoginHint()
					}
				}
			},
			async myopenid(path) {
				if (this.$root.platform == 'wx') {
					//debugger
					if (window.openid !== "") {
						localStorage.setItem('openid', window.openid);
					}

					// read uninid
					var localOpenid = localStorage.getItem('openid');

					if (localOpenid) {
						window.openid = localOpenid;
					}

					// if null then redirect
					// if(process.env.NODE_ENV == 'production')
					if (!localOpenid) {
						const auth = await this.$forceGetAuth();
						head.auth = auth;
					}

				}
			},

			dealUrl(actionurl) {
				const item = {}
				
				if(actionurl.indexOf('#/LyhMLink/') == 0) {
					// #/LyhMLink/lyhurl?actionurl=bHloOi8vbmF0aXZlLmxpYW5neWlodWkubmV0L05ld1dlYj9sb2dpbj0xJnVybD1odHRwczovL2RvY3Rvci5saWFuZ3lpaHVpLm5ldC8jL0x1Y2t5RHJhdw%3D%3D
					item.goUrl = actionurl;
					return item;
				}

				if(actionurl.indexOf('http') == 0) {
					// http://......  https://......
					item.goUrl = actionurl;
					return item;
				}

				if (actionurl.indexOf('http') > -1) {
					if(actionurl.indexOf('?url=')!=-1||actionurl.indexOf('&url=')!=-1){
							item.goUrl = actionurl.split('url=')[1];
					}else{
						item.goUrl = actionurl;
					}
					return item;
				}

				if (actionurl == "") {
					return actionurl;
				}

				// native的链接
				// lyh://native.liangyihui.net/Series?listID=154
        		var subject = actionurl.split('net/')[1].split('?')[0];
				if (actionurl.indexOf("?") > -1) {
					var id = actionurl.split('net/')[1].split('?')[1].split('=')[1];
				}

				// NewsDetail  Live  CommentDetail Series
				// 专栏 专题 公开课 普通文章
				switch (subject) {
					case "NewsDetail":
						item.goUrl = "#/doc/" + (id ? id : "");
						item.type = "doc";
						item.id = id;
						break;
					case "live":
						item.goUrl = "#/live/" + (id ? id : "");
						item.type = "live";
						item.id = id;
						break;
					case "Series":
						item.goUrl = "#/subject/" + (id ? id : "");
						item.type = "subject";
						item.id = id;
						break;
					case "ColumnDetail":
						item.goUrl = "#/column/" + (id ? id : "");
						item.type = "column";
						item.id = id;
						break;
					default:
						item.goUrl = "javascript:void(0)"
				}

				return item;

			}

		}
	},
	install(Vue, options) {
		Vue.filter('showdate', function (timestamp, mode) {
			if (timestamp == '请选择会诊日期') {
				return '请选择会诊日期';
			}
			if (!timestamp) {
				return '';
			}
			var re = timestamp;

      if (mode === 'all') { //年月日时分秒
        re = timeStamp2String(re, 'all');
      }else if (mode === 'md') { //月日
				re = timeStamp2String(re, 'md2');
			} else if (mode === 'hm') { //时分
				re = timeStamp2String(re, 'Hi');
			} else if (mode === 'ymdhm') { //年月日时分
				re = timeStamp2String(re, 'l');
			} else if (mode === 'symdhm') { //年月日时分
				re = timeStamp2String(re, 'sl');
			} else if (mode === 'ydhm') { //月日时分
				re = timeStamp2String(re, 's');
			} else if (mode === 'ny') {//今天昨天年月日时分
				re = timeStamp2String(re, 'ny');
			} else if (mode === 'ny4subjectlist') {
				//样式：
				// 1、今年的日期显示为： 今天、昨天、月日
				// 2、往年的日期显示为：年月日
				re = timeStamp2String(re, 'ny4subjectlist');
			} else if (mode === 'afda') {
				re = timeStamp2String(re, 'afda');
			}else if (mode === 'yyyy年MM月dd日') {
        re = timeStamp2String(re, 'yyyy年MM月dd日');
      }else if (mode === 'MM月dd日 hh:mm auto') {
        if(new Date().getFullYear()===new Date(timestamp*1000).getFullYear()){
          re = timeStamp2String(re, 'MM月dd日 hh:mm');
        } else {
          re = timeStamp2String(re,'yyyy年MM月dd日 hh:mm')
        }
      }else if (mode === 'mm:ss auto') {
        if (timestamp < 60) {
          re = timestamp + '秒';
        } else if (timestamp >= 60 && timestamp < 3600) {
          re = Math.floor(timestamp/60) + '分' + timestamp%60 + '秒'
        } else {
          var h = Math.floor(timestamp/3600)
          var seconds= timestamp%3600
          if(seconds<60){
            re = h + '小时' + 0 +'分' + timestamp + '秒'
          } else {
            re = h + '小时' + Math.floor(timestamp/60) + '分' + timestamp%60 + '秒'
          }
        }
      } else {
				re = timeStamp2String(re, 'sd');
			}
			return re;
		});

		Vue.filter('filesize', function (size) { // KB
			var re = '';
			if (size < 1024) {
				re = size + 'KB';
			} else if (size < 1024 * 1024) {
				re = parseInt((size / 1024) * 10) / 10 + 'MB';
			} else if (size < 1024 * 1024 * 1024) {
				re = parseInt((size / 1024 / 1024) * 10) / 10 + 'GB';
			} else if (size < 1024 * 1024 * 1024 * 1024) {
				re = parseInt((size / 1024 / 1024 / 2014) * 10) / 10 + 'TB';
			}
			return re;
		});

		Vue.filter('subjectType', function (eventType) {
			var re = '';
			if (eventType == 1) {
				// re = "学术会议";
				re = "会议专题";
			}
			if (eventType == 2) {
				// re = "公开课";
				re = "公开课专题";
			}
			if (eventType == 3) {
				// re = "运营会议";
				re = "会议专题";
			}
			if (eventType == 4) {
				re = "新闻专题";
			}
			// if(eventType == 5) {
			//   re = "特殊用途";
			// }
			if (eventType == 6) {
				re = "抗癌直播间";
			}
			if (eventType == 7) {
				re = "患者公众号";
			}
			if (eventType == 8) {
				re = "PPT专题";
			}
			if (eventType == 9) {
				re = "活动专题";
			}
			if (eventType == 10){
				re = "病例专题"
			}
			return re;
		});

		Vue.filter('sexstring', function (sexcode) {
			var re = '';
			if (sexcode == 0) {
				re = "未填写";
			}
			if (sexcode == 1) {
				re = "女";
			}
			if (sexcode == 2) {
				re = "男";
			}

			return re;
		});

    Vue.filter('patientsexstring', function (sexcode) {
      var re = '';
      if (sexcode == 0) {
        re = "未填写";
      }
      if (sexcode == 1) {
        re = "男";
      }
      if (sexcode == 2) {
        re = "女";
      }

      return re;
    });

		Vue.filter('hidename', function (name) {
			if (!name || !name.length) {
				return '***';
			}
			return name.substr(0, 1) + '**';
		});

		Vue.filter('showmoney', function (value) {
			var value = Math.round(parseFloat(value)) / 100;
			var xsd = value.toString().split(".");
			if (xsd.length == 1) {
				value = value.toString() + ".00";
				return value;
			}
			if (xsd.length > 1) {
				if (xsd[1].length < 2) {
					value = value.toString() + "0";
				}
				return value;
			}
		});

		Vue.filter('ShowPayType', function (value) {
			var type = '';
			if (value == 1) {
				type = '充值'
			} else if (value == 2) {
				type = '阅读红包'
			} else if (value == 3) {
				type = '提现'
			} else if (value == 4) {
				type = '购买'
			} else if (value == 5) {
				type = '活动红包'
			} else if (value == 6) {
				type = '会诊服务费'
			} else if (value == 7) {
				type = '患者报到'
			} else if (value == 8) {
				type = '年终头条'
			} else if (value == 9) {
				type = '开年红包'
			} else if (value == 10) {
				type = '定时红包'
			} else if (value == 11) {
        type = '完成问卷红包'
      } else if (value == 12) {
        type = '图文咨询'
      } else if (value == 13) {
        type = '图文问诊'
      } else if (value == 14) {
        type = '视频咨询'
      } else if (value == 15) {
        type = '第二诊疗意见'
      } else if (value == 16) {
        type = '一问一答'
      } else if (value == 17) {
        type = '在线答疑'
      } else if (value == 18) {
        type = '图片红包'
      } else if (value == 19) {
        type = '答题红包'
      } else if (value == 20) {
        type = '影像读片'
      } else if (value == 21) {
        type = '电话咨询'
      } else if (value == 24){
        type = '2022CSCO指南会认证红包'
      } else if (value == 25){
        type = '快速问答'
      } else if (value == 26){
			  //互联网医院计时服务
        type = '服务时长'
      } else if (value == 27){
        type = '学术季活动'
      } else if (value == 28) {
				// 患者端 AI 病历夹 打赏医生
				type = '送心意'
			}
			return type
		});

		Vue.filter('ShowPayStatus', function (value) {
			var type = '';
			if (value == 0) {
				type = '处理中'
			} else if (value == 1) {
				type = '已到账'
			} else if (value == 2) {
				type = '失败或拒绝'
			}
			return type
		});

		Vue.filter('showDocType', function (value) {
			var type = '';
			if (value == 6 || value == 9) {
				type = '公开课'
			} else {
				type = '文章'
			}
			return type
		});

		Vue.filter('showOtherTime', function (value) {
			var time;
			if (value < 60) {
				time = value + '秒'
			} else if (60 <= value && value < 3600) {
				time = Math.floor(value / 60) + "分" + value % 60 + "秒"
			} else if (3600 <= value && value < 86400) {
				time = Math.floor(value / 3600) + "小时"
			} else if (value >= 86400) {
				time = Math.ceil(value / 86400) + "天" + Math.floor((value % 86400) / 3600) + "小时"
			}
			return time
		});

		Vue.filter('sendTime', function (sentTime, pretime) {
			console.log(sentTime - pretime)
			if (Math.abs(sentTime - pretime) > 300000) {
				return sentTime / 1000
			}
		});

		Vue.filter('getallflowers', function (allflowers) {

			if (allflowers < 1000) {
				return allflowers
			} else if (1000 < allflowers && allflowers < 10000 || allflowers == 1000) {
				var f = parseFloat(allflowers / 1000);
				var s = parseInt(f * 100) / 100
				return s + 'k'
			} else if (allflowers > 10000 || allflowers == 10000) {
				var f = parseFloat(allflowers / 10000);
				var s = parseInt(f * 100) / 100
				return s + 'w'
			}
		});

		Vue.filter('FDLevel', function (type) {
			var re = '_';

			//console.log(type);

			//type = parseFloat(type);

			if (type == 0) {
				re = 0;
			}

			if (type == "0.1" || type == "3.5") {
				re = 1;
			}
			if (type == 0.9 || type == 1.9 || type == 2.9 || type == 3.9 || type == 4.9 || type == 5.9) {
				re = 2;
			}
			if (type == 1 || type == 2 || type == 3 || type == 4 || type == 5 || type == 6) {
				re = 3;
			}

			return re;
		});

		Vue.filter('progresstimes', function (times) {
			if (times == 0) {
				return "0" + 0 + ":" + "0" + 0;
			} else {
				times = Math.ceil(times);
				var minutetime = parseInt(times / 60) > 9 ? parseInt(times / 60) : "0" + parseInt(times / 60);
				var secondtime = (times % 60) > 9 ? (times % 60) : "0" + (times % 60);
				return minutetime + ":" + secondtime;
			}

		});

		Vue.filter('getFirststring', function (times) {
			if (times) {
				return times.charAt(0)
			} else {
				return '';
			}

		});

		Vue.filter('addPreZero', function (item) {
			if (item < 10) {
				return '0' + item
			} else {
				return item;
			}

		});

		Vue.filter('setColumntitle', function (item) {

			return item.split(",");
		});

		Vue.filter('setnoteTypeID', function (item) {
			var re;

			switch (item) {
				case 13:
					re = '诊断信息';
					break;
				case 14:
					re = '出院小结';
					break;
				case 15:
					re = '用药信息';
					break;
				case 16:
					re = '肿瘤评估';
					break;

			}
			return re
		});

		Vue.filter('setcurativeEffect', function (item) {
			var re;
			switch (item) {
				case 1:
					re = 'CR';
					break;
				case 2:
					re = 'PR';
					break;
				case 3:
					re = 'SD';
					break;
				case 4:
					re = 'PD';
					break;
				case 5:
					re = 'NE（不可评估）';
					break;
				case 6:
					re = 'NA（未做评估）';
					break;
			}
			return re
		});

		Vue.filter('setmedicationType', function (item) {
			var re;
			switch (item) {
				case 0:
					re = '联合用药';
					break;
				case 1:
					re = '单一用药';
					break;
			}
			return re
		});

		Vue.filter('setnoteTypepic', function (item) {
			var re;

			switch (item) {
				case 13:
					re = '基因检测';
					break;
				case 14:
					re = '出院小结';
					break;
				case 16:
					re = '检查报告';
					break;

			}
			return re
		});

		Vue.filter('setmedicationNumber', function (item) {
			var re;

			switch (item) {
				case 1:
					re = '辅助治疗';
					break;
				case 2:
					re = '新辅助治疗';
					break;
				case 3:
					re = '一线';
					break;
				case 4:
					re = '二线';
					break;
				case 5:
					re = '三线及以后';
					break;
			}
			return re
		});

		Vue.filter('setdiseaseTransferred', function (item) {
			var re;

			if (item) {
				re = item.replace(/>><</g, ',');
			}
			// re = item.replace('>><<',',');

			return re
		});

		Vue.filter('set35name', function (item) {
			var re;

			if (item) {

				re = item.substring(item.indexOf("_") + 1);
			}
			// re = item.replace('>><<',',');

			return re
		});

		// Vue.filter('setpercentage', function(item1,item2,item3) {
		//   var re;
		//   var val1 = parseInt(item1);
		//   var val2 = parseInt(item2);
		//   if(!val1&&!val2){
		//     re = 50+'%'
		//   }else {
		//     var perc = parseInt((val1/(val1+val2))*100);
		//     re = perc+'%'
		//   }
		//   return re
		// });

		Vue.filter('setpercentage', function () {
			var re;
			var arr = [...arguments];

			var total = 0;

			arr.forEach((item) => {
				total += parseInt(item);
			});
			var val1 = parseInt(arr[0]);

			if (!total) {
				re = 50 + '%'
			} else {
				var perc = parseInt((val1 / (total)) * 100);
				re = perc + '%'
			}
			return re
		});

		Vue.directive('ltest', {

			bind: function (el, binding, vnode) {
				var v = binding.value;
				if (v) {
					if (v.length > 0) {

					} else {
						el.innerHTML = ''
					}
				} else {
					el.innerHTML = ''
				}
				//console.log(binding.value)
			}
		});

		Vue.directive('drag', {
			inserted(el, binding) {
				let oDiv = el
				let maxLeft = el.parentNode.clientWidth - el.clientWidth
				let maxTop = el.parentNode.clientHeight - el.clientHeight
				oDiv.onmousedown = function (e) {
					//  鼠标按下，计算当前元素距离可视区的距离
					let disX = e.clientX - oDiv.offsetLeft
					let disY = e.clientY - oDiv.offsetTop
					document.onmousemove = function (e) {
						//  获取到鼠标拖拽后的横向位移(距离父级元素)
						let l = e.clientX - disX
						//  获取到鼠标拖拽后的纵向位移(距离父级元素)
						let t = e.clientY - disY

						oDiv.style.left = l + 'px'
						oDiv.style.top = t + 'px'
						if (e.clientX - disX <= 0) {
							oDiv.style.left = 0 + 'px'
						}

						if (e.clientY - disY <= 0) {
							oDiv.style.top = 0 + 'px'
						}

						if (e.clientX - disX >= maxLeft) {
							oDiv.style.left = maxLeft + 'px'
						}

						if (e.clientY - disY >= maxTop) {
							oDiv.style.top = maxTop + 'px'
						}

						//     将此时的位置传出去
						binding.value({
							x: oDiv.style.left,
							y: oDiv.style.top
						})
					}
					document.onmouseup = function (e) {
						document.onmousemove = null
						document.onmouseup = null
					}
				}
			}
		});

		Vue.directive('realslid', {
			inserted(el) {

				var gapheight;
				var number = 0;
				var oldY = 0;
				var distanceY;
				var startscrollTop;
				el.ontouchstart = function (event) {
					oldY = event.touches[0].pageY;
					gapheight = el.parentNode.offsetHeight - el.offsetHeight;
					if (el.offsetHeight == el.parentNode.offsetHeight) {
						event.preventDefault();
						return
					}
				};
				el.addEventListener('touchmove', function (event) {

					startscrollTop = el.parentNode.scrollTop;
					distanceY = event.touches[0].pageY - oldY;
					oldY = event.touches[0].pageY;

					if (startscrollTop == 0 && distanceY > 0) {
						event.preventDefault();
						return
					}

					if (el.parentNode.scrollTop == 0 && number != 0 && distanceY > 0) {
						event.preventDefault();
						return
					}

					if (el.parentNode.scrollHeight - el.parentNode.scrollTop == el.parentNode.clientHeight && distanceY < 0) {
						event.preventDefault();
						return
					}
					number++;
				});
			}
		});

		let messageBox = Vue.extend(messageBoxVue);
		let $messageBox = new messageBox();
		document.body.appendChild($messageBox.$mount().$el);


		Vue.prototype.$messageBox = (model => {
			// if($messageBox.model.show){
			//
			// }else {
			//   model.show=true;
			// }

			$messageBox.model = model;
		});

	}
}
